import {createSelector} from "../../../__snowpack__/pkg/@reduxjs/toolkit.js";
function selectWhiteLabelBase(state) {
  return state.whiteLabel;
}
export const selectTheme = createSelector([selectWhiteLabelBase], (whiteLabel) => whiteLabel.theme_config);
export const selectConfig = createSelector([selectWhiteLabelBase], (whiteLabel) => whiteLabel);
